import { IPricingOverride } from '../../../data/entities/pricing';
import { getIndividualDatesInRange, getISODateStringNoTime } from './calendar-helpers';

export const getOverridesPayload = (
	existingOverrides: IPricingOverride[] | undefined,
	ranges: Array<[Date, Date]>,
	priceSmartOrCustom: 'smart' | 'custom',
	override?: Partial<IPricingOverride>): IPricingOverride[] => {
	// only take the attributes we need to form the payload to send to the DB
	const strippedExistingOverrides = existingOverrides ?
		existingOverrides.map((existingOverride: IPricingOverride) => {
			const { checkin_available, discounts, effective_date, min_stay, price: overridePrice } = existingOverride;
			const strippedOverride = { checkin_available, discounts, effective_date, price: overridePrice };
			// only send min_stay if it has a value, sending null to DB returns an error
			const minStayStr = 'min_stay';
			if (min_stay) strippedOverride[minStayStr] = min_stay;
			return strippedOverride;
		}
		) : undefined;

	// populate this array with every individual date contained within the selected ranges
	const datesToUpdate: Date[] = [];
	ranges.forEach((range) => {
		const dates = getIndividualDatesInRange(range);
		dates.forEach((date) => datesToUpdate.push(date));
	});

	// if we are setting price to 'smart', this array will remain empty
	const newOverrides: IPricingOverride[] = [];
	// array of the dates to be updated as strings
	const effectiveDatesArray: string[] = [];
	// if setting price to 'smart', price won't be used
	const price = priceSmartOrCustom === 'custom' && override?.price ? override.price * 10000 : undefined;

	datesToUpdate.forEach((date) => {
		// get date in format expected in payload
		const effectiveDate = getISODateStringNoTime(date);
		effectiveDatesArray.push(effectiveDate);
		// if we're sending new overrides, add them to the array
		if (priceSmartOrCustom === 'custom' && price) newOverrides.push({ effective_date: effectiveDate, price });
	});

	// remove any existing overrides where the effective_date is one of the dates we are updating
	const strippedExistingOverridesNoDuplicateDates = strippedExistingOverrides ?
		strippedExistingOverrides.filter((strippedOverride: IPricingOverride) => !effectiveDatesArray.includes(strippedOverride.effective_date)) :
		undefined;

	// build payload by taking existing overrides minus dates we are updating, plus new overrides if there are any
	const payload = strippedExistingOverridesNoDuplicateDates ?
		strippedExistingOverridesNoDuplicateDates.concat(newOverrides as any[]) :
		newOverrides;

	return payload;
};
